module.exports = "/static/media/Loader_svg.8edb5b9a.svg";